function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 8,
  fill: "#D4F1EC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.75 11.5874H20.25C20.5484 11.5874 20.8345 11.7059 21.0455 11.9169C21.2565 12.1279 21.375 12.414 21.375 12.7124V14.0624H19.9125V13.0499H16.0875V14.0624H14.625V12.7124C14.625 12.414 14.7435 12.1279 14.9545 11.9169C15.1655 11.7059 15.4516 11.5874 15.75 11.5874Z",
  fill: "#17463F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.025 15.1875C11.025 14.8891 11.1436 14.603 11.3545 14.392C11.5655 14.181 11.8517 14.0625 12.15 14.0625H23.85C24.1484 14.0625 24.4345 14.181 24.6455 14.392C24.8565 14.603 24.975 14.8891 24.975 15.1875V18.1125H11.025V15.1875Z",
  fill: "#17463F"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.025 19.2375H24.975V23.2875C24.975 23.5859 24.8565 23.8721 24.6455 24.083C24.4345 24.294 24.1484 24.4125 23.85 24.4125H12.15C11.8517 24.4125 11.5655 24.294 11.3545 24.083C11.1436 23.8721 11.025 23.5859 11.025 23.2875V19.2375Z",
  fill: "#17463F"
});

function SvgJobUpdates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobUpdates);
export default __webpack_public_path__ + "static/media/job-updates.4526d110.svg";
export { ForwardRef as ReactComponent };